import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { PermissionService } from '@core/services/permission-service/permission-service'
import { PERMISSIONS } from '@app/core/constants/permissions.constants'

/**
 * When applied to the home routes, redirects CSL dual-approval users (client + proposal)
 * to Organisation Approvals (client tab) after login.
 */
export const cslApprovalsHomeGuard: CanActivateFn = async () => {
    const router = inject(Router)
    const permissionService = inject(PermissionService)

    await permissionService.getPermissionsBitwise()
    if (
        permissionService.getPermissionByName(PERMISSIONS.APPROVE_CLIENT) &&
        permissionService.getPermissionByName(PERMISSIONS.APPROVE_PROPOSAL)
    ) {
        return router.parseUrl('/crm/csl-approvals/client')
    }
    return true
}
